

























































































































































































































import Vue from 'vue'

export default Vue.extend({

    name: 'Wind',
    metaInfo: {
        title: 'The Effects of Winds',
        meta : [
            {
                name: 'description',
                content : 'Understand how wind affects houses and the importance of the tie down chain through several examples from damage investigations.'
            },
            {
                name: 'keywords',
                content : 'Wind loads, houses, tie-down chain, uplift loads, wind damage, damage investigations, retrofitting, cyclone, weather, storm, protection'
            }
        ]
    },


    data: () => ({



    }),
    computed: {

    },
})
